import { useQuery } from '@tanstack/react-query';
import { useNotification } from '../useNotification';
import { useFetchApi } from '../useFetchApi';
import { MessageAttempt } from '../../shared/types';

type UseListMessageAttemptsProps = {
  webhookId?: string;
  pollInterval?: number | undefined;
};

export const useMessageAttempts = ({
  webhookId,
  pollInterval = undefined,
}: UseListMessageAttemptsProps) => {
  const fetch = useFetchApi();
  const { showErrorWithResponse } = useNotification();

  const listMessageAttempts = useQuery({
    queryKey: ['messageAttempts', webhookId],
    queryFn: () =>
      fetch(`webhooks/${webhookId}/attempts`) as Promise<MessageAttempt[]>,
    onError: showErrorWithResponse,
    enabled: !!webhookId,
    refetchOnWindowFocus: false,
    refetchInterval: pollInterval,
    refetchIntervalInBackground: false,
  });

  return listMessageAttempts;
};
